import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'
import Card from '../../../../components/Card'
import Reveal from './Reveal'

type Props = {
  icon?: LucideIcon
  logoSrc?: string
  title: string
  description: string
  children: ReactNode
}

const Callout = ({
  icon: Icon,
  logoSrc,
  title,
  description,
  children,
}: Props) => (
  <Reveal className='h-full'>
    <Card className='flex h-full flex-col items-start gap-4 p-6'>
      <div className='flex items-start gap-4'>
        <div className='flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary'>
          {logoSrc ? (
            <img src={logoSrc} alt={title} className='h-7 w-7 object-contain' />
          ) : Icon ? (
            <Icon className='h-7 w-7' />
          ) : null}
        </div>
        <div className='flex flex-col gap-1'>
          <h2 className='text-lg font-medium mb-0'>{title}</h2>
          <p className='text-sm text-muted-foreground'>{description}</p>
        </div>
      </div>
      <div className='mt-auto flex flex-wrap gap-2'>{children}</div>
    </Card>
  </Reveal>
)

export default Callout
